import { Box, spacing, useIsDesktopView, useIsMobileView } from 'deepstash-ui';
import useAuth from 'providers/hooks/useAuth';
import React, { useCallback } from 'react';
import SignUpBanner from 'src/components/banner/SignUpBanner';
import SubsectionHeader from 'src/components/metacontent/components/SubsectionHeader';
import NextLink from 'src/components/navigation/NextLink';
import SourceCollapsed from 'src/components/source/source-collapsed/SourceCollapsed';
import SourceNSIArticleGradient from 'src/page-components/source/components/SourceNSIArticleGradient';
import { Analytics, Events } from 'src/services/analytics';
import { Source } from 'types/models';
import { BLOCK_WIDTH_REM, slugify, SQUARE_WIDTH_REM } from 'utils/global';
import commonStrings from 'utils/strings/commonStrings';

interface TopicContentProps {
  sources: Source[];
}

const TopicContentNSI: React.FC<TopicContentProps> = ({ sources }) => {
  const isDesktopView = useIsDesktopView();
  const isMobileView = useIsMobileView();
  const { isLoggedIn } = useAuth();

  const getHref = useCallback(
    source => `/article/${source.id}/${slugify(source.title)}`,
    [],
  );

  const onPreviewClick = (source: Source) => {
    Analytics.logEvent({
      eventName: Events.consumption.sourcePreviewClick,
      properties: {
        sourceId: source.id,
        element: 'preview-idea',
        location: 'hashtag-screen',
      },
      platforms: ['amplitude'],
    });
  };

  const mainLayoutSectionHeight = !isMobileView ? spacing.toRem(1400) : 'unset';

  const renderItem = (source: Source, index: number) => {
    return (
      <Box
        onClick={() => onPreviewClick(source)}
        key={`topic-source-${source.id}-${index}`}
        filter={index > 4 ? 'blur(4px)' : ''}
      >
        <NextLink href={getHref(source)}>
          <SourceCollapsed
            key={source.id}
            source={source}
            mb={SQUARE_WIDTH_REM}
          />
        </NextLink>
      </Box>
    );
  };

  return (
    <Box pos="relative" zIndex={3}>
      <Box
        height={mainLayoutSectionHeight}
        overflowY={'hidden'}
        pos="relative"
        zIndex={3}
      >
        {!isLoggedIn && <SourceNSIArticleGradient />}
        <SubsectionHeader>
          {commonStrings.allIdeas.toUpperCase()}
        </SubsectionHeader>
        {/* first of all render 2 items, then SignUpBanner if NSI and on Tablet or Moblie */}
        {sources.map((source, index) => renderItem(source, index))}
      </Box>
      {!isLoggedIn && (
        <SignUpBanner
          size={isDesktopView ? 'lg' : 'sm'}
          mt={isDesktopView ? BLOCK_WIDTH_REM : 0}
          mb={isDesktopView ? 0 : SQUARE_WIDTH_REM}
        />
      )}
    </Box>
  );
};

export default TopicContentNSI;
